'use strict';
import React from 'react';
import './App.css';

const Footer = () => {
    return (
        <footer>
        <p>&copy; 2024 Flow. All rights reserved.</p>
        <p>Designed by Kate Kodama, Nila Ragu, and Renee Singh</p>
        </footer>
    );
}

export default Footer;